module.exports = __webpack_public_path__ + "static/media/vendors-logo.8d1b9e90.svg";